import React, { useEffect, useState } from "react";
import Quagga from "@ericblade/quagga2";
import { useNavigate } from "react-router-dom";
import Header from "./components/header";
import Footer from "./components/footer";

const _getMedian = (arr) => {
  arr.sort((a, b) => a - b);
  const half = Math.floor(arr.length / 2);
  if (arr.length % 2 === 1)
    // Odd length
    return arr[half];
  return (arr[half - 1] + arr[half]) / 2.0;
};

const BarcodeScanner = () => {
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(false);
  const [medianLimit, setMedianLimit] = useState(0.1);
  const [videoWidth, setVideoWidth] = useState({
    min: 1280,
    ideal: 1920,
    max: 4096,
  });
  const [videoHeight, setVideoHeight] = useState({
    min: 720,
    ideal: 1440,
    max: 2160,
  });
  const [aspectRatio, setAspectRatio] = useState({ min: 1, max: 2 });
  const [petchSize, setPetchSize] = useState("medium");
  const [numOfWorkers, setNumOfWorkers] = useState(2);
  const [frequency, setFrequency] = useState(20);

  const onDetected = (result) => {
    const errors = result.codeResult.decodedCodes
      .filter((_) => _.error !== undefined)
      .map((_) => _.error);
    const median = _getMedian(errors);

    if (median < medianLimit) {
      Quagga.stop();
      navigate(`/result/${result.codeResult.code}`);
    }
  };

  useEffect(() => {
    if (showMenu) {
      return;
    }
    Quagga.init(
      {
        inputStream: {
          type: "LiveStream",
          constraints: {
            width: videoWidth,
            height: videoHeight,
            // width: { min: 4000 },
            // height: { min: 3000 },
            facingMode: "environment",
            aspectRatio: aspectRatio,
            advanced: [{ focusMode: "auto" }],
          },
        },
        locator: {
          patchSize: petchSize,
          halfSample: true,
        },
        numOfWorkers: numOfWorkers,
        frequency: frequency,
        decoder: {
          readers: ["upc_reader", "ean_reader"],
          debug: {
            showCanvas: true,
            showPatches: true,
            showFoundPatches: true,
            showSkeleton: true,
            showLabels: true,
            showPatchLabels: true,
            showRemainingPatchLabels: true,
            boxFromPatches: {
              showTransformed: true,
              showTransformedBox: true,
              showBB: true,
            },
          },
        },
        locate: true,
      },
      (err) => {
        if (err) {
          console.error(err);
          return;
        }
        Quagga.start();
      }
    );

    Quagga.onProcessed(function (result) {
      var drawingCtx = Quagga.canvas.ctx.overlay,
        drawingCanvas = Quagga.canvas.dom.overlay;

      if (result) {
        if (result.boxes) {
          drawingCtx.clearRect(
            0,
            0,
            parseInt(drawingCanvas.getAttribute("width")),
            parseInt(drawingCanvas.getAttribute("height"))
          );
          result.boxes
            .filter(function (box) {
              return box !== result.box;
            })
            .forEach(function (box) {
              Quagga.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, {
                color: "green",
                lineWidth: 5,
              });
            });
        }

        if (result.box) {
          Quagga.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, drawingCtx, {
            color: "#00F",
            lineWidth: 5,
          });
        }

        if (result.codeResult && result.codeResult.code) {
          Quagga.ImageDebug.drawPath(
            result.line,
            { x: "x", y: "y" },
            drawingCtx,
            { color: "red", lineWidth: 5 }
          );
        }
      }
    });

    Quagga.onDetected(onDetected);

    return () => {
      Quagga.offDetected();
      Quagga.stop();
    };
  }, [onDetected]);

  return (
    <div>
      <div id="interactive" className="viewport"></div>
      </div>
  )
}
 
export default BarcodeScanner;
